module.exports = __webpack_public_path__ + "assets/img/icn_map_marker.svg";